import React, { FC } from 'react'

import { IconType } from '../../common/types'

const NucUpload: FC<IconType> = ({
  iconColor = 'currentColor',
  ...svgProps
}) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...svgProps}
    >
      <path
        d='M14.418 9.94531V12.9271C14.418 13.3225 14.2609 13.7017 13.9813 13.9813C13.7017 14.2609 13.3225 14.418 12.9271 14.418H2.49089C2.09548 14.418 1.71627 14.2609 1.43667 13.9813C1.15707 13.7017 1 13.3225 1 12.9271V9.94531'
        stroke={iconColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.4361 4.72721L7.7089 1L3.98169 4.72721'
        stroke={iconColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.70898 1V9.94531'
        stroke={iconColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default NucUpload
